import {registerGlobal} from "./core.js";

class UserInteraction {
	static isMouseMoved = false;
	static listenerAdded = false;
	static pageLoadTime;
	static minInteractionDelay = 1000; // 1 second threshold

	static init() {
		if (!this.listenerAdded) {
			this.listenerAdded = true;
			this.pageLoadTime = Date.now();
			const controller = new AbortController();
			const signal = controller.signal;

			// Pass the signal to all listeners
			const options = { signal, once: true };
			['mousemove', 'mousedown', 'keydown', 'touchmove', 'touchstart', 'touchend'].forEach(event => {
				document.addEventListener(event, (e) => this.checkMM(e, controller), options);
			});

			setInterval(function () {
				Net.fetch(API_URL_REL +'account/tok', {
					method: "GET",
				}).then((data) => {
					if (data && data.tok) {
						$$("#cftoken1").val(data.tok);
						const cftoken = $$("#cftoken");
						if (cftoken.val()) {
							cftoken.val(data.tok);
						}
					}
				});
			}, 270000); //4:30 minutes
		}
	}

	static checkMM(e, controller) {
		if (!e.isTrusted) {
			Logger.warn('Synthetic (fake) event detected, ignoring.');
			return;
		}

		const delay = Date.now() - this.pageLoadTime;
		if (delay < this.minInteractionDelay) {
			Logger.warn(`Interaction too fast (${delay}ms), ignoring.`);
			return;
		}

		// Immediately cancel ALL listeners
		controller.abort();

		let t = $$("#cftoken1").val();
		$$("#cftoken").val(t);
		this.isMouseMoved = true;
	}
}
registerGlobal('UserInteraction', UserInteraction);
